<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.applicant}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-radio-group :label="labels.appIntStat" v-model="fireForm.applicant.appIntStat" row :error-messages="errors.collect('appIntStat')" data-vv-name="appIntStat" :data-vv-as="labels.appIntStat" v-validate="'required'" @change="doAppIntStat">
                    <v-radio v-for="status in appIntStatList" :key="status.value" :label="status.label" :value="status.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                </v-flex>
                <template v-if="fireForm.applicant.appIntStat === 'E'">
                  <v-flex lg6 xs12>
                    <v-text-field key="coyName" v-model="fireForm.applicant.coyName" :label="labels.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="labels.coyName" v-validate="'required|name|max:50'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field v-model="fireForm.applicant.coyRocUen" :label="labels.coyRocUen" :error-messages="errors.collect('coyRocUen')" data-vv-name="coyRocUen" :data-vv-as="labels.coyRocUen" v-validate="'entry|max:20'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field v-model="fireForm.applicant.coyNature" :label="labels.coyNature" :error-messages="errors.collect('coyNature')" data-vv-name="coyNature" :data-vv-as="labels.coyNature" v-validate="'entry|max:128'"></v-text-field>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex lg6 xs12>
                    <v-autocomplete key="appSalutation" :items="salutationList" v-model="fireForm.applicant.appSalutation" :label="labels.appSalutation" item-text="label" item-value="value" data-vv-name="appSalutation" :data-vv-as="labels.appSalutation" :error-messages="errors.collect('appSalutation')" v-validate="'required'" @input="doSalutation"></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appName" v-model="fireForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appNricPassport" v-uppercase="fireForm.applicant.appNricPassport" v-model="fireForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'required|alpha_num|max:20'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker key="appDob" v-model="fireForm.applicant.appDob" :label="labels.appDob" v-validate="{ required: true, bday_range:[globalCommonForm.startDate, 21, 100]}" :data-vv-as="labels.appDob" data-vv-name="appDob" :error-messages="errors.collect('appDob')"></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-radio-group key="appGender" v-model="fireForm.applicant.appGender" row :label="labels.appGender" :error-messages="errors.collect('appGender')" data-vv-name="appGender" :data-vv-as="labels.appGender" v-validate="'required'">
                      <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex lg6 xs12>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appOccupation" v-model="fireForm.applicant.appOccupation" :label="labels.appOccupation" :error-messages="errors.collect('appOccupation')" data-vv-name="appOccupation" :data-vv-as="labels.appOccupation" v-validate="'name|max:60'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appJointApplicant" v-model="fireForm.applicant.appJointApplicant" :label="labels.appJointApplicant" :error-messages="errors.collect('appJointApplicant')" data-vv-name="appJointApplicant" :data-vv-as="labels.appJointApplicant" v-validate="'name|max:60'"></v-text-field>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appContact}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appEmail" type="email" :label="labels.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'required|email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.appMobileNo" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" v-validate="{ required: (fireForm.applicant.appIntStat === 'I'), numeric: true }" hint="Mobile No. is required to receive SMS confirmation" :persistent-hint="true" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo1" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo2" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :data-vv-as="labels.appPostalCode" v-validate="'required|numeric'" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'required|entry|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'required|entry|max:255'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.mailAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="fireForm.applicant.mailAdd" :label="labels.mailAdd" data-vv-name="mailAdd" :data-vv-as="labels.mailAdd" :error-messages="errors.collect('mailAdd')" @change="doMailAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.mailAdd3" :label="labels.mailAdd3" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.mailAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="fireForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.mailPostalCode" :label="labels.mailPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :readonly="fireForm.applicant.mailAdd" :data-vv-as="labels.mailPostalCode" v-validate="'numeric'" :loading="mailPostalCodeLoading" @change="doMailAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.mailAdd1" :label="labels.mailAdd1" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.mailAdd1" v-validate="'entry|max:30'" :readonly="fireForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.mailAdd2" :label="labels.mailAdd2" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.mailAdd2" v-validate="'entry|max:255'" :readonly="fireForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.applicant.mailAdd4" :label="labels.mailAdd4" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.mailAdd4" v-validate="'entry|max:255'" :readonly="fireForm.applicant.mailAdd"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.riskInfo}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="fireForm.riskAdd" :label="labels.riskAdd" data-vv-name="riskAdd" :data-vv-as="labels.riskAdd" :error-messages="errors.collect('riskAdd')" @change="doRiskAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.riskAdd3" :label="labels.riskAdd3" :error-messages="errors.collect('riskAdd3')" data-vv-name="riskAdd3" :data-vv-as="labels.riskAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="fireForm.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.riskPostalCode" :label="labels.riskPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('riskPostalCode')" data-vv-name="riskPostalCode" :readonly="fireForm.riskAdd" :data-vv-as="labels.riskPostalCode" v-validate="'required|numeric'" :loading="riskPostalCodeLoading" @change="doRiskAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.riskAdd1" :label="labels.riskAdd1" :error-messages="errors.collect('riskAdd1')" data-vv-name="riskAdd1" :data-vv-as="labels.riskAdd1" v-validate="'required|entry|max:30'" :readonly="fireForm.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.riskAdd2" :label="labels.riskAdd2" :error-messages="errors.collect('riskAdd2')" data-vv-name="riskAdd2" :data-vv-as="labels.riskAdd2" v-validate="'required|entry|max:255'" :readonly="fireForm.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="fireForm.riskAdd4" :label="labels.riskAdd4" :error-messages="errors.collect('riskAdd4')" data-vv-name="riskAdd4" :data-vv-as="labels.riskAdd4" v-validate="'entry|max:255'" :readonly="fireForm.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete :items="quoteParam.constrnCls" v-model="fireForm.constrnCls" :label="labels.constrnCls" item-text="label" item-value="value" data-vv-name="constrnCls" :data-vv-as="labels.constrnCls" :error-messages="errors.collect('constrnCls')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete :items="quoteParam.occupancy" v-model="fireForm.occupancy" :label="labels.occupancy" item-text="label" item-value="value" data-vv-name="occupancy" :data-vv-as="labels.occupancy" :error-messages="errors.collect('occupancy')" v-validate="'required'" :loading="occupancyLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_FIRE_RISK, QUOTE_FIRE_PARAM } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { salutation, gender, maritalStatus, applicantStatus } from '@/const/underwriting'
import { expandURI } from '@/utils/ajax'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status*',
        appName: 'Name as in NRIC/Passport*',
        appSalutation: 'Salutation*',
        appNricPassport: 'NRIC/Passport*',
        appDob: 'Date of Birth*',
        appGender: 'Gender*',
        appOccupation: 'Business/Profession',
        appJointApplicant: 'Joint Applicant (if any)',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appAdd1: 'Block/House No.*',
        appAdd2: 'Street Name*',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code*',
        mailAdd: 'Same as Applicant Address',
        mailAdd1: 'Block/House No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailPostalCode: 'Postal Code',
        appContact: 'Contacts',
        appEmail: 'Email*',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company*',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business',
        riskInfo: 'Risk Information',
        riskAdd: 'Same as Applicant Address',
        riskAdd1: 'Block/House No.*',
        riskAdd2: 'Street Name*',
        riskAdd3: 'Unit No.',
        riskAdd4: 'Building Name',
        riskPostalCode: 'Postal Code*',
        constrnCls: 'Property Type*',
        occupancy: 'Occupancy*'
      },
      fireForm: {
        applicant: {
          appIntStat: undefined,
          appSalutation: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appGender: undefined,
          appOccupation: undefined,
          appJointApplicant: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          coyName: undefined,
          coyRocUen: undefined,
          coyNature: undefined
        },
        riskAdd: undefined,
        riskAdd1: undefined,
        riskAdd2: undefined,
        riskAdd3: undefined,
        riskAdd4: undefined,
        riskPostalCode: undefined,
        constrnCls: undefined,
        occupancy: undefined
      },
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false,
      riskPostalCodeLoading: false,
      occupancyLoading: false
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.fireParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.fireForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    appIntStatList() {
      // Convert object to arr
      let result = []
      Object.keys(applicantStatus).forEach(function (key) {
        const status = applicantStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    'fireForm.applicant.appAdd1': function (value) {
      if (this.fireForm.applicant.mailAdd) {
        this.fireForm.applicant.mailAdd1 = value
      }
      if (this.fireForm.riskAdd) {
        this.fireForm.riskAdd1 = value
      }
    },
    'fireForm.applicant.appAdd2': function (value) {
      if (this.fireForm.applicant.mailAdd) {
        this.fireForm.applicant.mailAdd2 = value
      }
      if (this.fireForm.riskAdd) {
        this.fireForm.riskAdd2 = value
      }
    },
    'fireForm.applicant.appAdd3': function (value) {
      if (this.fireForm.applicant.mailAdd) {
        this.fireForm.applicant.mailAdd3 = value
      }
      if (this.fireForm.riskAdd) {
        this.fireForm.riskAdd3 = value
      }
    },
    'fireForm.applicant.appAdd4': function (value) {
      if (this.fireForm.applicant.mailAdd) {
        this.fireForm.applicant.mailAdd4 = value
      }
      if (this.fireForm.riskAdd) {
        this.fireForm.riskAdd4 = value
      }
    },
    'fireForm.applicant.appPostalCode': function (value) {
      if (this.fireForm.applicant.mailAdd) {
        this.fireForm.applicant.mailPostalCode = value
      }
      if (this.fireForm.riskAdd) {
        this.fireForm.riskPostalCode = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      // Applicant
      const { applicant } = this.globalCommonForm
      this.fireForm.applicant.appIntStat = applicant.appIntStat
      this.fireForm.applicant.appSalutation = applicant.appSalutation
      this.fireForm.applicant.appName = applicant.appName
      this.fireForm.applicant.appGender = applicant.appGender
      this.fireForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.fireForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.fireForm.applicant.appOccupation = applicant.appOccupation
      this.fireForm.applicant.appJointApplicant = applicant.appJointApplicant
      this.fireForm.applicant.appEmail = applicant.appEmail
      this.fireForm.applicant.appMobileNo = applicant.appMobileNo
      this.fireForm.applicant.appTelNo1 = applicant.appTelNo1
      this.fireForm.applicant.appTelNo2 = applicant.appTelNo2
      this.fireForm.applicant.appPostalCode = applicant.appPostalCode
      this.fireForm.applicant.appAdd1 = applicant.appAdd1
      this.fireForm.applicant.appAdd2 = applicant.appAdd2
      this.fireForm.applicant.appAdd3 = applicant.appAdd3
      this.fireForm.applicant.appAdd4 = applicant.appAdd4
      this.fireForm.applicant.mailAdd = applicant.mailAdd
      this.fireForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.fireForm.applicant.mailAdd1 = applicant.mailAdd1
      this.fireForm.applicant.mailAdd2 = applicant.mailAdd2
      this.fireForm.applicant.mailAdd3 = applicant.mailAdd3
      this.fireForm.applicant.mailAdd4 = applicant.mailAdd4
      this.fireForm.applicant.coyName = applicant.coyName
      this.fireForm.applicant.coyRocUen = applicant.coyRocUen
      this.fireForm.applicant.coyNature = applicant.coyNature

      this.fireForm.riskAdd = this.globalForm.riskAdd
      this.fireForm.riskAdd1 = this.globalForm.riskAdd1
      this.fireForm.riskAdd2 = this.globalForm.riskAdd2
      this.fireForm.riskAdd3 = this.globalForm.riskAdd3
      this.fireForm.riskAdd4 = this.globalForm.riskAdd4
      this.fireForm.riskPostalCode = this.globalForm.riskPostalCode
      this.fireForm.constrnCls = this.globalForm.constrnCls
      this.fireForm.occupancy = this.globalForm.occupancy

      // Default values
      if (!this.fireForm.applicant.appIntStat && this.appIntStatList && this.appIntStatList.length > 0) {
        // Default 1st value if not found
        this.fireForm.applicant.appIntStat = this.appIntStatList[0].value
      }

      // Load Some Params
      if (this.quoteParam.occupancy === undefined || this.quoteParam.occupancy.length === 0) {
        this.getOccupancy()
      }
    },
    async getOccupancy() {
      const apiURI = this.$store.state.agency.quotation.menu.occupancy
      if (apiURI) {
        try {
          this.occupancyLoading = true
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              occupancy: data.data
            }
            this.$store.commit(QUOTE_FIRE_PARAM, commitResult)
            this.occupancyLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.occupancyLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doAppIntStat() {
      // Reset some values
      if (this.fireForm.applicant.appIntStat && this.fireForm.applicant.appIntStat === 'E') {
        this.fireForm.applicant.appSalutation = undefined
        this.fireForm.applicant.appName = undefined
        this.fireForm.applicant.appNricPassport = undefined
        this.fireForm.applicant.appDob = undefined
        this.fireForm.applicant.appGender = undefined
        this.fireForm.applicant.appOccupation = undefined
        this.fireForm.applicant.appJointApplicant = undefined
      } else if (this.fireForm.applicant.appIntStat && this.fireForm.applicant.appIntStat === 'I') {
        this.fireForm.applicant.coyName = undefined
        this.fireForm.applicant.coyRocUen = undefined
        this.fireForm.applicant.coyNature = undefined
      }
    },
    doSalutation() {
      if (this.fireForm.applicant.appSalutation === 'MR') {
        this.fireForm.applicant.appGender = 'M'
      } else if (this.fireForm.applicant.appSalutation === 'MS' || this.fireForm.applicant.appSalutation === 'MDM' || this.fireForm.applicant.appSalutation === 'MRS') {
        this.fireForm.applicant.appGender = 'F'
      } else {
        if (!this.fireForm.applicant.appGender || this.fireForm.applicant.appGender === null) {
          this.fireForm.applicant.appGender = 'M'
        }
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.fireForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.fireForm.applicant.appAdd1 = data.add1
            this.fireForm.applicant.appAdd2 = data.add2
            this.fireForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doMailAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.mailPostalCodeLoading = true
          const expand = {
            postCode: this.fireForm.applicant.mailPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.fireForm.applicant.mailAdd1 = data.add1
            this.fireForm.applicant.mailAdd2 = data.add2
            this.fireForm.applicant.mailAdd4 = data.add4
          }
          this.mailPostalCodeLoading = false
        } catch (err) {
          this.mailPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doRiskAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.riskPostalCodeLoading = true
          const expand = {
            postCode: this.fireForm.riskPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.fireForm.riskAdd1 = data.add1
            this.fireForm.riskAdd2 = data.add2
            this.fireForm.riskAdd4 = data.add4
          }
          this.riskPostalCodeLoading = false
        } catch (err) {
          this.riskPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doMailAdd() {
      this.fireForm.applicant.mailAdd1 = this.fireForm.applicant.appAdd1
      this.fireForm.applicant.mailAdd2 = this.fireForm.applicant.appAdd2
      this.fireForm.applicant.mailAdd3 = this.fireForm.applicant.appAdd3
      this.fireForm.applicant.mailAdd4 = this.fireForm.applicant.appAdd4
      this.fireForm.applicant.mailPostalCode = this.fireForm.applicant.appPostalCode
    },
    doRiskAdd() {
      this.fireForm.riskAdd1 = this.fireForm.applicant.appAdd1
      this.fireForm.riskAdd2 = this.fireForm.applicant.appAdd2
      this.fireForm.riskAdd3 = this.fireForm.applicant.appAdd3
      this.fireForm.riskAdd4 = this.fireForm.applicant.appAdd4
      this.fireForm.riskPostalCode = this.fireForm.applicant.appPostalCode
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'fireQuotePlans' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.fireForm.applicant.appMobileNo && this.fireForm.applicant.appMobileNo !== '') ||
            (this.fireForm.applicant.appTelNo1 && this.fireForm.applicant.appTelNo1 !== '') ||
            (this.fireForm.applicant.appTelNo2 && this.fireForm.applicant.appTelNo2 !== '')) {
            this.$store.commit(QUOTE_FIRE_RISK, this.fireForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
            this.$router.push({ name: 'fireQuotePremium' })
          } else {
            this.promptFieldCheck()
            this.errorMessage('At least one of the contact number is required')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_FIRE_RISK, this.fireForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
